import React from "react";
import { Paper, Box, Typography, Alert, Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useTranslation } from "react-i18next";

interface PermissionsErrorProps {
  onRetry: () => void;
}

export const PermissionsError: React.FC<PermissionsErrorProps> = ({
  onRetry,
}) => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 3 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          <Typography variant="h6" gutterBottom>
            {t("failedToLoadUsers")}
          </Typography>
          <Typography variant="body2">
            {t("failedToLoadUsersDescription")}
          </Typography>
        </Alert>
        <Button
          variant="contained"
          startIcon={<RefreshIcon />}
          onClick={onRetry}
        >
          {t("retry")}
        </Button>
      </Box>
    </Paper>
  );
};
